import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Tooltip } from 'react-tooltip';
import { isiOSDevice as isIOSDevice } from '../../../constants/deviceType';
import useOnboardingTooltip from '../../../hooks/useOnboardingTooltip';
import InputContainer from './InputContainer';
import IOSInputContainer from './IOSInputContainer';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 200;
`;

function InputBar(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

  // Store the latest executeRecaptcha function in a ref
  const executeRecaptchaRef = useRef(null);

  const containerRef = useRef();
  const tooltipDisabled = useOnboardingTooltip(containerRef, 0);

  // Update the ref whenever executeRecaptcha changes
  useEffect(() => {
    executeRecaptchaRef.current = executeRecaptcha;

    if (executeRecaptcha) {
      setRecaptchaLoaded(true);
    }
  }, [executeRecaptcha]);

  const sendMessage = (messageData) => {
    // Handle both old string format and new object format
    let messageText;
    if (typeof messageData === 'string') {
      messageText = messageData;
    } else {
      messageText = messageData.messageText;
    }

    // Prevent empty messages and whitespace-only messages
    if (!messageText || messageText.trim().length === 0) {
      return;
    }

    const currentExecuteRecaptcha = executeRecaptchaRef.current;

    if (!currentExecuteRecaptcha) {
      console.error('reCAPTCHA not available');
      return;
    }

    currentExecuteRecaptcha('submit')
      .then((token) => {
        props.sendMessage(messageData, token);
      })
      .catch((error) => {
        console.error('Failed to execute reCAPTCHA:', error);
      });
  };

  return (
    <Container>
      <Container
        ref={containerRef}
        data-tooltip-id='input-bar-tooltip'
        data-tooltip-content="Type here to send a message, you'll be assigned an anonymous nickname. All messages disappear after a few minutes."
      >
        {!props.useChatLayout && isIOSDevice() ? (
          <IOSInputContainer
            sendMessage={sendMessage}
            enabled={props.enabled}
            replyToMessage={props.replyToMessage}
            hasSubscription={props.hasSubscription}
          ></IOSInputContainer>
        ) : (
          <InputContainer
            sendMessage={sendMessage}
            enabled={props.enabled}
            replyToMessage={props.replyToMessage}
            hasSubscription={props.hasSubscription}
          ></InputContainer>
        )}
      </Container>
      <Tooltip
        id='input-bar-tooltip'
        isOpen={!tooltipDisabled}
        place='top'
        offset={10}
        anchorSelect='[data-tooltip-id="input-bar-tooltip"]'
      />
    </Container>
  );
}

export default InputBar;
